import { createColumnHelper } from '@tanstack/react-table';

import { ContainerRowData } from '../types';

export const columnHelper = createColumnHelper<ContainerRowData>();
